import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "preview", "image", "title", "description", "navbar", "shared_with"]

  static values = {
    page: String,
    filter: String
  }

  initialize() {
    if(this.element.getAttribute("data-locale")) {
      this.locale = this.element.getAttribute("data-locale");
    }
    if(this.element.getAttribute("data-url")) {
      this.url = this.element.getAttribute("data-url");
    }
  }

  connect() {
    this.getUrlPreview(this.url);

    if(this.hasNavbarTarget) {
      let navLink;
      if(this.filterValue == "") {
        navLink = this.navbarTarget.querySelector(`a[data-page="personal"]`);
      } else if(this.filterValue == "shared") {
        navLink = this.navbarTarget.querySelector(`a[data-page="shared"]`);
      } else if(this.filterValue == "projects") {
        navLink = this.navbarTarget.querySelector(`a[data-page="projects"]`);
      }

      if(navLink) {
        navLink.classList.add("text-white")
      }
    }
  }

  getUrlPreview(url) {
    var bookmarksController = this;
    Rails.ajax({
      url: `/${this.locale}/bookmark/preview?url=${this.url}`,
      type: "get",
      data: "",
      success: function(data) {
        if(data) {
          if(data.image != '') {
            bookmarksController.imageTarget.src = data.image;
          } else {
            bookmarksController.imageTarget.classList.add('d-none');
            bookmarksController.imageTarget.parentNode.innerHTML = "<center><i class='far fa-image fa-4x text-muted mt-3'></i></center>"
          }
          bookmarksController.titleTarget.innerHTML = data.title;
          bookmarksController.descriptionTarget.innerHTML = data.description;
          bookmarksController.previewTarget.classList.remove('d-none');
        }
      },
      error: function(data) {}
    });
  }

  toggleShareWith() {
    switch(event.target.value) {
      case "shared":
        this.shared_withTarget.classList.remove('d-none')
        break;
      default:
        this.shared_withTarget.classList.add('d-none')
    }
  }
}
